import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'

import Loader from '../../shared/components/Loader'
import PaneWrapper from '../components/PaneWrapper'
import Pane from '../components/Pane'

@inject('program', 'auth') @observer
class PaneContainer extends Component {

  static propTypes = {
    auth: PropTypes.object,
    program: PropTypes.object,
  }

  componentWillMount() {
    const { program } = this.props
    // reload if the length is currently below 2 which indicates that only
    // a single model was loaded sofar
    if (program.collection.length < 2) {
      this.load()
    }
  }

  load() {
    const { program } = this.props
    if (!program.loading) {
      program.load({ reset: true })
    }
  }

  @autobind
  handleLoad() {
    this.load()
  }

  render() {
    const { program } = this.props

    if (program.loading && !program.length) {
      return (
        <PaneWrapper>
          <Loader>Programme werden geladen...</Loader>
        </PaneWrapper>
      )
    }

    return (
      <Pane
        onLoad={this.handleLoad}
        data={program}
      />
    )
  }

}

const PaneContainerWithRouter = withRouter(PaneContainer)

export { PaneContainerWithRouter as default }



// WEBPACK FOOTER //
// ./src/program/containers/Pane.js